<agpr-dialog-container
    heading="Discover.csvExport.header"
    [id]="'csvExportDialog'"
    [contentPadding]="false"
    (close)="cancel()"
>
    <div
        class="agpr-csvExport"
        [agprLoading]="loading"
    >
        <div class="agpr-csvExport-panel">
            <div>
                {{'Discover.csvExport.instructions' | localize}}
            </div>

            <div class="agpr-csvExport-fields-flexContainer">
                <agpr-panel
                    [contentPadding]="false"
                    [toggleable]="false"
                    header="Discover.csvExport.contactData"
                >
                    <agpr-scroll-panel>
                        <div
                            *ngFor="let category of contactFields"
                            class="agpr-csvExport-fields-section"
                        >
                            <agpr-checkbox
                                [id]="category.label + '_checkbox'"
                                class="agpr-csvExport-fields-categoryCheckbox"
                                [label]="category.label"
                                [binary]="true"
                                [hiddenLabel]="('selectAll' | localize) + ' ' + (category.label | localize)"
                                [(ngModel)]="category.checked"
                                (ngModelChange)="categoryToggled(category)"
                            >
                            </agpr-checkbox>
                            <ul [attr.aria-label]="category.label | localize">
                                <li
                                    *ngFor="let field of category.fields"
                                    class="agpr-csvExport-fields-fieldCheckbox"
                                >
                                    <agpr-checkbox
                                        [id]="field.enumValue + '_checkbox'"
                                        [label]="field.label"
                                        [disabled]="field.disabled"
                                        [value]="field"
                                        [(ngModel)]="category.selectedFields"
                                        (ngModelChange)="fieldToggled(category)"
                                    >
                                    </agpr-checkbox>
                                </li>
                            </ul>
                        </div>
                    </agpr-scroll-panel>
                </agpr-panel>
                <agpr-panel
                    [contentPadding]="false"
                    [toggleable]="false"
                    header="Discover.csvExport.outletData"
                >
                    <agpr-scroll-panel>
                        <div
                            *ngFor="let category of outletFields"
                            class="agpr-csvExport-fields-section"
                        >
                            <agpr-checkbox
                                [id]="category.label + '_checkbox'"
                                class="agpr-csvExport-fields-categoryCheckbox"
                                [label]="category.label"
                                [binary]="true"
                                [hiddenLabel]="('selecAll' | localize) + ' ' + (category.label | localize)"
                                [(ngModel)]="category.checked"
                                (ngModelChange)="categoryToggled(category)"
                            >
                            </agpr-checkbox>
                            <ul [attr.aria-label]="category.label | localize">
                                <li
                                    *ngFor="let field of category.fields"
                                    class="agpr-csvExport-fields-fieldCheckbox"
                                >
                                    <agpr-checkbox
                                        [id]="field.enumValue + '_checkbox'"
                                        [label]="field.label"
                                        [disabled]="field.disabled"
                                        [value]="field"
                                        [(ngModel)]="category.selectedFields"
                                        (ngModelChange)="fieldToggled(category)"
                                    >
                                    </agpr-checkbox>
                                </li>
                            </ul>
                        </div>
                    </agpr-scroll-panel>
                </agpr-panel>
            </div>
        </div>
        <div class="agpr-csvExport-panel rhp">
            <agpr-text-input
                [id]="'csvExportDialog.filenameInput'"
                [(ngModel)]="filename"
                placeholder="Discover.csvExport.filename.placeholder"
                label="Discover.csvExport.filename.label"
                [required]="true"
                [maxLength]="255"
            ></agpr-text-input>
            <div class="agpr-csvExport-options">
                <agpr-checkbox
                    id="csvExportDialog_includeLists_checkbox"
                    label="Discover.csvExport.options.includeLists"
                    [binary]="true"
                    [(ngModel)]="includeLists"
                >
                </agpr-checkbox>
            </div>
            <agpr-scroll-panel class="agpr-csvExport-receipt">
                <div class="agpr-csvExport-receipt-label">{{'Discover.csvExport.contactData' | localize}}</div>
                <div>
                    <ng-container
                        *ngFor="let category of contactFields"
                    >
                        <div
                            *ngIf="category.selectedFields.length > 0"
                            class="agpr-csvExport-receipt-chipSection"
                        >
                            <agpr-chip-container [readonly]="true" [chips]="category.selectedFields"></agpr-chip-container>
                        </div>
                    </ng-container>
                </div>

                <div class="agpr-csvExport-receipt-label">{{'Discover.csvExport.outletData' | localize}}</div>
                <div>
                    <ng-container
                        *ngFor="let category of outletFields"
                    >
                        <div
                            *ngIf="category.selectedFields.length > 0"
                            class="agpr-csvExport-receipt-chipSection"
                        >
                            <agpr-chip-container [readonly]="true" [chips]="category.selectedFields"></agpr-chip-container>
                        </div>
                    </ng-container>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.confirmDialog.cancel'"
            label="Core.button.cancel"
            [disabled]="loading"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.confirmDialog.saveAsDefault'"
            [style]="buttonTypes.primaryB"
            label="Discover.distribution.footer.settings.setAsDefault"
            (click)="saveAsDefault()"
        >
        </agpr-button>
        <agpr-button
            [id]="id + '.confirmDialog.ok'"
            [style]="buttonTypes.primary"
            label="Discover.batchActions.export"
            [disabled]="loading || filename.length === 0"
            (click)="ok()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
